let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eY2r6")).then(() => parcelRequire('ipuf7'));